import { ProductParsedDescription } from '../types';

export const DefaultDescriptionParseMapper: ProductParsedDescription = {
    Description: ['Description', 'product highlights'],
    Ingredients: ['Nutritional Information', 'Active Ingredients', 'Ingredients for'],
    Size: ['Size', 'Collar Sizing Help', 'Available sizes'],
    Directions: [
        'Directions',
        'Feeding Instructions',
        'Instructions',
        'Instruction Guide',
        'Cleaning Instructions',
        'Care Instructions',
        'Instruction Manual',
    ],
};
